import script from "./PaymentsViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsViewPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsViewPage.vue?vue&type=style&index=0&id=0ba74433&scoped=true&lang=css"
import "./PaymentsViewPage.vue?vue&type=style&index=1&id=0ba74433&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba74433"]])

export default __exports__